import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';
import { EconomicactivitiesService } from 'src/app/services/economicactivities.service';
import { EconomicactivitiesModalComponent } from './economicactivities-modal/economicactivities-modal.component';



@Component({
  selector: 'app-economicactivities',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './economicactivities.component.html',
  styleUrls: ['./economicactivities.component.css']
})
export class EconomicactivitiesComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private EconomicactivitiesService: EconomicactivitiesService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  EconomicactivitiesList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getEconomicactivities();
  }

  getEconomicactivities(){
    this.EconomicactivitiesService.getEconomicactivities().subscribe({
      next: (res: any) => {
        this.EconomicactivitiesList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      }});
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(EconomicactivitiesModalComponent, {
      data: { item, mode, title }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getEconomicactivities();
        }
      }
    });
  }

}
